import React, { useState } from 'react';
import Styles from './styles.module.css';
import { CiCircleQuestion } from "react-icons/ci";


type QuestionCardProps = {
  number: number;
  questions: string[];
  initialChoice?: number;
  setQuestions: React.Dispatch<React.SetStateAction<string>>;
  onChange: (value: number) => void;
};

const CIRCLE_SCALE = 0.7;

const getSize = (i: number) => {
  const base = i === 1 || i === 7 ? 40 : i === 2 || i === 6 ? 32 : i === 3 || i === 5 ? 24 : 20;
  return base * CIRCLE_SCALE;
};

export const QuestionCard: React.FC<QuestionCardProps> = ({ initialChoice, questions, onChange, setQuestions }) => {

  // const SCORE_MAP = [0, 16, 32, 50, 68, 84, 100];
  const SCORE_MAP = [100, 84, 68, 50, 32, 16, 0];

  const scoreToIndex = (score?: number) => {
    if (score == null) return undefined;
    return SCORE_MAP.indexOf(score);
  };

  // const [ choice, setChoice ] = useState<number | undefined>(initialChoice);
  const [choice, setChoice] = useState<number | undefined>(
    scoreToIndex(initialChoice)
  );

  const handleClick = (i: number) => {
    setChoice(i);
    onChange(i);
  };


  const UI_VALUES = [0, 1, 2, 3, 4, 5, 6];

  return (
    <div className={Styles.card}>

      <div className={Styles.labels}>
        <span className={Styles.pole} onClick={() => setQuestions(questions[0])}>
          {questions[0]}
          <CiCircleQuestion className={Styles.labels_questions} />
        </span>
        <span className={Styles.pole} onClick={() => setQuestions(questions[1])}>
          {questions[1]}
          <CiCircleQuestion className={Styles.labels_questions} />
        </span>
      </div>

      <div className={Styles.bar}>
        {UI_VALUES.map((i) => {

          const score = SCORE_MAP[i];

          const size = getSize(score);
          const isSelected = choice === i;
          const ringColor = isSelected ? "var(--mw-brand)" : "var(--mw-field-border)";

          return (
            <div
              key={i}
              onClick={() => handleClick(i)}
              className={Styles.circle}
              style={{ width: size, height: size, borderColor: ringColor }}
            >
              {isSelected && (
                <div
                  style={{
                    width: size * 0.65,
                    height: size * 0.65,
                    backgroundColor: "var(--mw-brand)",
                    borderRadius: "50%",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

